import { AppState } from '../root-reducer';

export const selectNotifications = (state: AppState) => state.notificationDomain.notifications;
export const selectNotificationsLoading = (state: AppState) => state.notificationDomain.loading;
export const selectNotificationsOpen = (state: AppState) => state.notificationDomain.open;
export const selectNotificationsAllLoaded = (state: AppState) => state.notificationDomain.allNotificationsLoaded;
